import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import Iconify from '../../../../components/Iconify';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { useMutation } from 'react-fetching-library';
import { changeAccommodationOwnershipAction } from '../../../../services/request';
import { useApp } from '../../../../AppContext';

export const DiagramDataSyncDialog = ({ open, setOpen }) => {
  const { setQueryOrdersSignal, selectedAccomodationDiagram, setSelectedAccomodationDiagram,
    setShowOwnershipDialog, setSavingDisabled } = useAccomodationDiagram();
  const { mutate: changeOwnershipMutate, loading } = useMutation(changeAccommodationOwnershipAction);
  const { ownershipHash } = useApp();

  const handleSubmit = async () => {
    const { error, payload, status } = await changeOwnershipMutate({ ownershipHash, verify: true }, selectedAccomodationDiagram.id);
    if (!error) {
      setSelectedAccomodationDiagram(payload);
      setQueryOrdersSignal(true);
    } else if (status == 428) {
      setShowOwnershipDialog(true);
      setSavingDisabled(true);
    }
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={() => {}}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
          <Iconify icon="eva:info-fill" color="#007BFF" /> <Typography color="primary">Aktualizacja diagramu</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography color="primary">
          Zmieniono dane jednej z imprez, bądź zamówienia na diagramie, wczytuję dane ponownie.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} disabled={loading} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
